// Customizable Area Start
export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const leftArrow = require("../assets/leftArrow.png");
export const dummyProduct = require("../assets/dummy-image.jpg");

// Customizable Area End
